<template>
  <nuttrema-layout-content>

    <template slot="header">
      <stuff-to-eat-standard-header
        :edit.sync="edit"
        :meta="meta"
        :StuffToEatDetails="ProductDetails">
      </stuff-to-eat-standard-header>
    </template>

    <template slot="central">

      <nuttrema-loader v-if="ProductDetails.fetching || CategoriesQuestionnaire.fetching"></nuttrema-loader>

      <nuttrema-empty-result
        v-else-if="_isEmpty(CategoriesQuestionnaire, 'data')"
        icon="far fa-battery-slash">
        <template slot="text">
          <h1 v-html="$t('label.list_is_empty')"></h1>
          <h4 v-html="$t('label.create_first_item')"></h4>
        </template>
      </nuttrema-empty-result>

      <form-category-questionnaire
         v-else
        :edit.sync="edit"
        :section="section"
        :CategoriesQuestionnaire="CategoriesQuestionnaire"
        @submit="onFormSubmit">
      </form-category-questionnaire>

    </template>

    <router-view slot="overflow"></router-view>
  </nuttrema-layout-content>
</template>

<script>
import { mapActions } from 'vuex';

import StuffToEatStandardHeader from 'components/pages/professional/stuff-to-eat/shared/blocks/cmpt-stuff-to-eat-standard-header';
import PageCategoryQuestionnaire from 'components/pages/professional/shared/category-questionnaire/page-category-questionnaire';

import { STUFF_TO_EAT_ADVANCED_CATEGORISATION } from 'constants/stuff-to-eat-category';

export default {
  name: 'page-stuff-to-eat-categories',
  mixins: [PageCategoryQuestionnaire],
  components: {
    StuffToEatStandardHeader,
  },
  data() {
    return {
      section: STUFF_TO_EAT_ADVANCED_CATEGORISATION,
    };
  },
  computed: {
    ProductDetails() {
      return this.$store.getters.StuffToEatDetails(this.id);
    },
    CategoriesQuestionnaire() {
      return this.$store.getters.StuffToEatCategories(this.id);
    },
  },
  methods: {
    ...mapActions({
      SaveCategoryQuestionnaire: 'SaveStuffToEatCategories',
    }),
    fetchCategoryQuestionnaire() {
      this.$store.dispatch('GetStuffToEatCategories', { id: this.id, type: this.type, section: this.section });
    },
    clearCategoryQuestionnaire() {
      this.$store.dispatch('ClearStuffToEatCategories', { id: this.id });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/stuff-to-eat/shared/details/categories/page-stuff-to-eat-categories.vue